export enum UserPermission {
  DASHBOARD = 'DASHBOARD',
  ORDERS = 'ORDERS',
  PRODUCTS = 'PRODUCTS',
  USERS = 'USERS',
  PROFILE = 'PROFILE',
  SERVICES = 'SERVICES',
  SEND_REFERENCE_NUMBER_EMAIL = 'SEND_REFERENCE_NUMBER_EMAIL'
}
